module.exports = __webpack_public_path__ + "img/mp4.a728bde1.png";